module.exports = __webpack_public_path__ + "static/media/dosa.3899968c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dosa.jpg
// module id = 200
// module chunks = 0